module.exports = __webpack_public_path__ + "img/default.11298c4e.jpg";